{
  "phone-number-input": {
    "text": {
      "country-code": "Ländercode",
      "country-code-invalid": "Ungültig",
      "country-code-required": "Erforderlich",
      "phone-nr": "Telefonnummer",
      "phone-nr-invalid": "Handynummer ist ungültig",
      "phone-nr-required": "Handynummer ist erforderlich"
    }
  }
}
